// @flow
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, type IntlShape, defineMessages } from 'react-intl';
import core from '@bravissimolabs/website-core';
import Meta from 'shared/containers/MetaContainer';
import JobsMoreInfoPage from 'brastrap/editorial/jobs-more-info-page/JobsMoreInfoPage';
import type { JobsMoreInfoPage as JobsMoreInfoPageProps } from 'brastrap/editorial/jobs-more-info-page/jobs-more-info-page.types';
import { receiveVacancy } from 'shared/actions/jobs';

type Props = {
  intl: IntlShape,
  pageTitle?: string,
  pageDescription?: string,
  location?: string,
  ...JobsMoreInfoPageProps,
};

const messages = defineMessages({
  title: {
    id: 'vacancy.title',
    defaultMessage: '{job} | {location}',
  },
  description: {
    id: 'vacancy.description',
    defaultMessage:
      'We want our customers to celebrate their figures and feel good about themselves.' +
      " If you'd like to be part of that, we'd love to hear from you.",
  },
});

const VacancyMoreInfo = (props: Props) => (
  <Meta
    title={
      props.pageTitle ||
      props.intl.formatMessage(messages.title, {
        job: props.title,
        location: props.location,
      })
    }
    description={
      props.pageDescription || props.intl.formatMessage(messages.description)
    }
  >
    <JobsMoreInfoPage {...props} />
  </Meta>
);

/**
 * - Populate shop details
 *
 * @param {object} store
 * @param {object} props
 */
VacancyMoreInfo.populateStore = async (store, props) => {
  const api = core.jobs.jobs;

  const vacancy = await api.getVacancyWithMoreInfo(props.params.vacancy);
  if (!vacancy) {
    throw new Error('404');
  }

  store.dispatch(receiveVacancy(vacancy));
};

const mapStateToProps = state => ({
  ...state.jobs.vacancy,
});

export default connect(mapStateToProps)(injectIntl(VacancyMoreInfo));
